<template>
  <div class="PaapViewerParent">
    <div style="display: flex; gap: 1rem; margin-bottom: 1.75rem">
      <statistics-box class="solid-blue no-clickable">
        <i class="far fa-sack-dollar" slot="icon"></i>
        {{ prepareLocaleNumber(totalValueWithoutTva) }}
        <span slot="label-right">Total estimat</span>
      </statistics-box>
      <statistics-box class="solid-blue no-clickable">
        <i class="far fa-container-storage" slot="icon"></i>
        {{ totalRecords }}
        <span slot="label-right">Nr. referate</span>
      </statistics-box>
    </div>
    <!--     <div class="LAccordionParent nqowjkdnihvciax LAccordion-StickyStyle">
      <div class="LAccordionItem" :class="selected[1] ? 'LActive' : ''">
        <div @click="selectAccordion(1)" class="LAccordionItemHead">
          <span>Filtre <i class="fas fa-angle-down rotateToTop"></i></span>
          <div>
            <i class="fas fa-times"></i>
            <i style="font-size: 2rem" class="fas fa-chevron-down"></i>
          </div>
          <span @click.stop="" id="nvqoiokqndapo"></span>
        </div>
        <div class="LAccordionItemBody" :style="ACHcomputed['AC2']">
          <div ref="AC2">
            <PaapViewerFilter :paap="paap" @filter="filter" />
          </div>
        </div>
      </div>
    </div> -->
    <div class="panel-results">
      <h4 class="total-paap_result" style="padding: 0">
        {{ totalRecords }} Rezultat{{ totalRecords === 1 ? "" : "e" }}
      </h4>
      <!-- <div class="paap-preview_type">
        <span> Tip afișare: </span>
        <div>
          <div
            @click="changeViewType(false)"
            :class="{ active: !viewModeTable }"
          >
            <i class="fas fa-bars"></i>
          </div>
          <div @click="changeViewType(true)" :class="{ active: viewModeTable }">
            <i class="fas fa-table"></i>
          </div>
        </div>
      </div> -->
    </div>
    <div ref="referencesPreview" class="referencesPreview">
      <table-component
        v-if="viewModeTable"
        :reloadCount="tableReload"
        :tableHead="tableHead"
        :prepareFn="prepareData"
        :apiModule="tableModule"
        apiModuleName="PAAP_CENTRALIZATION_REFERENCE"
        @Btn14="viewPdf"
        @Btn3="deleteNr"
        @totalRecords="(x) => (totalRecords = x)"
        @mounted="scrollPreview"
      >
      </table-component>
      <!-- <template v-else-if="references.length" v-for="e in references">
        <div
          :key="e.id"
          style="border-left: 4px solid #347bb7; padding-left: 1rem"
        >
          <h4 style="color: #0276c8">{{ e.name }}</h4>
          <PaapReferencePreview
            :paap="paap"
            :reference="e"
            :usersAvatarCache="usersAvatarCache"
          />
        </div>
      </template> -->
      <div v-else style="margin-bottom: 10rem">
        <h4 class="prettyH4" style="color: #888">
          <i class="fas fa-exclamation-triangle"></i>
          Nu sunt referate
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import {
  REFERENCE_DELETE_PAAP,
  PAAP_CENTRALIZATION_REFERENCE,
  GET_PAAP_CENTRALIZATION,
} from "@/api.js";
import PermisionsMixin from "@/mixins/paapPermMixin.js";
import LAcordion from "@/mixins/LAcordion.js";
import PaapViewerFilter from "@/components/PaapViewerFilter";
import PaapReferencePreview from "@/components/PaapReferencePreview";
import TableComponent from "@/components/TableParent";
import { mapMutations } from "vuex";

const viewModeStorageKey = "paapPanelViewMode";

const tableData = () => ({
  options: {
    specialActions: {
      7: "showModalSlot",
      29: ["showModalSlot", "3"],
    },
  },
  head: [
    {
      title: "Denumire referat",
    },
    {
      title: "Cod CPV (dominant)",
    },
    {
      title: "Valoarea estimată totală, fără TVA",
    },
    {
      spacer: true,
      minimize: 1,
    },
  ],
  body: [],
});

export default {
  mixins: [PermisionsMixin, LAcordion],
  components: {
    PaapViewerFilter,
    PaapReferencePreview,
    TableComponent,
  },
  props: {
    paap: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      selected: {
        0: false,
        1: false,
      },
      tableModule: (x, y) =>
        PAAP_CENTRALIZATION_REFERENCE(
          x,
          y,
          this.$route.params.centralizationId,
        ),
      tableHead: [
        {
          title: "Denumire referat",
        },
        {
          title: "Cod CPV (dominant)",
        },
        {
          title: "Valoarea estimată totală, fără TVA",
        },
        {
          spacer: true,
          minimize: 1,
        },
      ],
      createdAt: null,
      viewModeTable: true,
      usersAvatarCache: {},
      tableReload: 0,
      totalRecords: 0,
      totalEstimatedValue: 0,
      centralization: null,
      filtered: [],
    };
  },
  watch: {
    viewModeTable: {
      handler(x) {
        this.scrollPreview();
        this.syncStorage();
      },
      immediate: true,
    },
  },
  computed: {
    totalValueWithoutTva() {
      return this.centralization?.totalValueWithoutTva || 0;
    },
  },
  methods: {
    ...mapMutations(["setReferenceIdForPreview"]),
    viewPdf(item) {
      this.setReferenceIdForPreview({
        data: {
          id: item.id,
        },
        origin: "REFERENCE_GET_PDF",
      });
    },
    scrollPreview() {
      if (Date.now() - this.createdAt < 1990) {
        return;
      }

      const findEl = document.querySelector(".panel-results");
      setTimeout(
        this.scrollElToTOp,
        199,
        findEl || this.$refs["referencesPreview"],
      );
    },
    selectAccordion(index) {
      if (!Number.isInteger(index)) return;
      this.selected[index] = !this.selected[index];
    },

    deleteNr(item) {
      const error = (msg) => {
        this.$toastr.e(msg || "Ștergerea referatului a eșuat.");
        this.setLoad(false);
        this.$emit("refresh");
      };
      this.setLoad(true);

      REFERENCE_DELETE_PAAP({
        id: item.id,
        paap: this.$route.params.id,
        centralizationId: this.$route.params.centralizationId,
      })
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            if (this.totalRecords < 2) {
              const paapId = this.$route.params.id;
              this.safePushRouter(
                `/${this.$route.params.navigation}/paap/${paapId}/centralizare`,
              );
            }

            this.$toastr.s(
              "Referatul de necesitate a fost șters din PAAP cu succes.",
            );
            this.tableReload++;
            this.setLoad(false);
          } else {
            error();
          }
        })
        .catch(error);
    },
    prepareData(row, showEmpty) {
      const buttons = [14];

      if (
        this.PERMISIONS.edit &&
        this.paap.approveVersion == 2 &&
        ["draft", "rejected"].includes(this.paap.paapStatus)
      ) {
        buttons.push([3, "Șterge"]);
      }

      return [
        row.name ?? "-",
        row.cpvCode ?? "-",
        this.prepareLocaleNumber(row.totalValueWithoutTva),
        [buttons],
      ];
    },

    filter(references) {
      if (!Array.isArray(references)) return;

      if (this.viewModeTable) {
        this.filtered = references;
      } else {
        this.simulateLoad(() => (this.filtered = references));
      }
    },
    syncStorage(readStorage) {
      if (readStorage) {
        this.viewModeTable =
          {
            extended: false,
            table: true,
          }[localStorage.getItem(viewModeStorageKey)] ?? true;
      } else {
        localStorage.setItem(
          viewModeStorageKey,
          {
            false: "extended",
            true: "table",
          }[this.viewModeTable],
        );
      }
    },
    changeViewType(type) {
      this.viewModeTable = !!type;
    },
  },
  created() {
    GET_PAAP_CENTRALIZATION(this.$route.params.centralizationId).then((res) => {
      this.centralization = res.data;
    });

    this.createdAt = Date.now();

    this.syncStorage(true);
  },
};
</script>

<style src="@/assets/LAcordion.css"></style>
<style src="@/assets/PaapViewer.css"></style>
